import api, { API_URL } from './api';
import { toast } from 'sonner';

// Never forward the CRM session to an arbitrary URL stored in a document.
export const privateFilePath = (source) => {
    const base = new URL(`${API_URL}/`);
    const value = source.startsWith('/') && !source.startsWith('/api/') ? source.slice(1) : source;
    const url = new URL(value, base);
    if (url.origin !== base.origin || !url.pathname.startsWith(`${base.pathname.replace(/\/$/, '')}/`)) {
        throw new Error('Adresse du document non autorisée');
    }
    url.searchParams.delete('token');
    return url.pathname.slice(base.pathname.length - 1) + url.search;
};

export const fetchPrivateFile = (source, signal) => api.get(privateFilePath(source), {
    responseType: 'blob', signal, timeout: 120000, skipRetry: true,
});

export const fileErrorMessage = async (error) => {
    let data = error.response?.data;
    if (data instanceof Blob) {
        try { data = JSON.parse(await data.text()); } catch { data = null; }
    }
    return typeof data?.detail === 'string' ? data.detail :
        error.response?.status === 403 ? 'Vous n’avez pas accès à ce fichier.' :
        'Le fichier n’a pas pu être chargé. Réessayez ; aucune suppression n’a été effectuée.';
};

export const saveFileBlob = (blob, filename) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url; link.download = filename || 'document';
    document.body.appendChild(link); link.click(); link.remove();
    // Revoking synchronously can cancel the browser download, especially on mobile.
    setTimeout(() => URL.revokeObjectURL(url), 60000);
};

export const downloadPrivateFile = async (source, filename) => {
    try { const { data } = await fetchPrivateFile(source); saveFileBlob(data, filename); }
    catch (error) { toast.error(await fileErrorMessage(error)); }
};

export const openPrivateFile = async (source) => {
    // Reserve the tab inside the user's click, before asynchronous authentication.
    const tab = window.open('about:blank', '_blank');
    if (!tab) { toast.error('Autorisez l’ouverture du document dans un nouvel onglet.'); return false; }
    tab.opener = null;
    tab.document.title = 'Chargement du document';
    tab.document.body.textContent = 'Chargement du document…';
    try {
        const { data } = await fetchPrivateFile(source);
        if (tab.closed) return false;
        const url = URL.createObjectURL(data);
        tab.location.replace(url);
        const timer = setInterval(() => {
            if (tab.closed) { URL.revokeObjectURL(url); clearInterval(timer); }
        }, 2000);
        return true;
    } catch (error) {
        tab.close(); toast.error(await fileErrorMessage(error)); return false;
    }
};